import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-[#E5E5E5]">
      <div className="max-w-7xl mx-auto px-6 py-6">
        <div className="flex items-center justify-between">
          {/* Logo - Even Larger */}
          <Link to="/" className="flex items-center">
            <img
              src="https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/tqgjb85d_element_logo_final_notext.png"
              alt="Element by Elena Mustakova"
              className="h-24 w-24 md:h-28 md:w-28 lg:h-32 lg:w-32"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <Link
              to="/work"
              className="text-base md:text-lg font-light text-[#2C2C2C] lowercase hover:text-[#2C1810] transition-colors duration-300"
            >
              {t('nav.work')}
            </Link>
            <Link
              to="/about"
              className="text-base md:text-lg font-light text-[#2C2C2C] lowercase hover:text-[#2C1810] transition-colors duration-300"
            >
              {t('nav.about')}
            </Link>
            <Link
              to="/press"
              className="text-base md:text-lg font-light text-[#2C2C2C] lowercase hover:text-[#2C1810] transition-colors duration-300"
            >
              {t('nav.press')}
            </Link>
            <Link
              to="/contact"
              className="text-base md:text-lg font-light text-[#2C2C2C] lowercase hover:text-[#2C1810] transition-colors duration-300"
            >
              {t('nav.contact')}
            </Link>
            <button
              onClick={toggleLanguage}
              className="text-base md:text-lg font-light text-[#2C2C2C] uppercase hover:text-[#2C1810] transition-colors duration-300 tracking-wider"
            >
              {language === 'en' ? 'BG' : 'EN'}
            </button>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-[#2C2C2C]"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="md:hidden mt-6 pt-6 border-t border-[#E5E5E5] flex flex-col gap-4">
            <Link
              to="/work"
              onClick={() => setMobileMenuOpen(false)}
              className="text-lg font-light text-[#2C2C2C] lowercase"
            >
              {t('nav.work')}
            </Link>
            <Link
              to="/about"
              onClick={() => setMobileMenuOpen(false)}
              className="text-lg font-light text-[#2C2C2C] lowercase"
            >
              {t('nav.about')}
            </Link>
            <Link
              to="/press"
              onClick={() => setMobileMenuOpen(false)}
              className="text-lg font-light text-[#2C2C2C] lowercase"
            >
              {t('nav.press')}
            </Link>
            <Link
              to="/contact"
              onClick={() => setMobileMenuOpen(false)}
              className="text-lg font-light text-[#2C2C2C] lowercase"
            >
              {t('nav.contact')}
            </Link>
            <button
              onClick={toggleLanguage}
              className="text-lg font-light text-[#2C2C2C] uppercase text-left tracking-wider"
            >
              {language === 'en' ? 'BG' : 'EN'}
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
